// extracted by mini-css-extract-plugin
module.exports = {"actions":"dual-cta-module--actions--1wbkV","button":"dual-cta-module--button--1FejC"};